import $ from 'jquery';
import React, { Component, Fragment } from 'react';
import autobind from 'class-autobind';
import withOnOutsideClick from 'react-onclickoutside';

import map from 'lodash/map';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';

import { GearIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';
import { OpacityTransition } from 'zoomforth_component_lib/transitions.jsx';
import SimpleModalWithHeader from 'zoomforth_component_lib/simple_modal_with_header.jsx';
import Toggle from 'zoomforth_component_lib/toggler.jsx';
import Button from 'zoomforth_component_lib/btn_basic.jsx';

import { PrivacyPolicyLink } from './initial_consent_modal.jsx';


const CookieDetails = ({ name, host, duration, type, category, description })=> (
  <div className="consent-cookie-details">
    <div className="consent-cookie-details-row">
      <div className="consent-cookie-details-type">
        Name
      </div>

      <div className="consent-cookie-details-value">
        { name }
      </div>
    </div>

    <div className="consent-cookie-details-row">
      <div className="consent-cookie-details-type">
        Host
      </div>

      <div className="consent-cookie-details-value">
        { host }
      </div>
    </div>

    <div className="consent-cookie-details-row">
      <div className="consent-cookie-details-type">
        Duration
      </div>

      <div className="consent-cookie-details-value">
        { duration }
      </div>
    </div>

    <div className="consent-cookie-details-row">
      <div className="consent-cookie-details-type">
        Type
      </div>

      <div className="consent-cookie-details-value">
        { type }
      </div>
    </div>

    <div className="consent-cookie-details-row">
      <div className="consent-cookie-details-type">
        Category
      </div>

      <div className="consent-cookie-details-value">
        { category }
      </div>
    </div>

    <div className="consent-cookie-details-row">
      <div className="consent-cookie-details-type">
        Description
      </div>

      <div className="consent-cookie-details-value">
        { description }
      </div>
    </div>
  </div>
);


const CookieListOption = ({
  cookieType,
  cookieTypeId,
  cookieTypeDescription,
  isChecked,
  isDisabled,
  isDetailsOpen,
  cookieDetails,
  onToggle,
  onCookieDetailsClick
})=> (
  <Fragment>
    <div className="consent-cookie-list-option">
      <div className="consent-cookie-type">
        <h3>{ cookieType }</h3>

        <p id={`consent-cookie-type-${cookieTypeId}`}>
          { cookieTypeDescription }
        </p>

        {
          !isEmpty(cookieDetails) &&
            <Button onClick={onCookieDetailsClick}>
              Cookie details
            </Button>
        }
      </div>

      <div className="consent-cookie-toggle">
        <Toggle
          tabIndex="-1"
          checked={isChecked}
          disabled={isDisabled}
          aria-labelledby={`consent-cookie-type-${cookieTypeId}`}
          onChange={onToggle}
        />
      </div>

    </div>

    {
      !isEmpty(cookieDetails) &&
        <div className="consent-cookie-list-option-details">
          <OpacityTransition transitionAppear={true}>
            {
              isDetailsOpen &&
                <Fragment>
                  {
                    map(cookieDetails, (cookie)=> (
                      <CookieDetails
                        key={cookie.name}
                        name={cookie.name}
                        host={cookie.host}
                        duration={cookie.duration}
                        type={cookie.type}
                        category={cookie.category}
                        description={cookie.description}
                      />
                    ))
                  }
                </Fragment>
            }
          </OpacityTransition>
        </div>
    }
  </Fragment>
);


class PrivacyPreferencesModal extends Component {

  constructor() {
    super();

    this.state = {
      isStrictlyNecessaryDetailsOpen: false,
      isSiteAccessDetailsOpen: false,
      isTrackingDetailsOpen: false
    };

    this.__mounted = false;

    autobind(this);
  }

  componentDidMount() {
    this.__mounted = true;
  }

  componentWillUnmount() {
    this.__mounted = false;
  }

  handleClickOutside() {
    this.props.onClosePreferencesClick();
  }

  render() {
    const {
      privacyPolicyUrl,
      isConsentCookieSet,
      hasConsentedToTracking,
      hasConsentedToAuthCookie,
      onAllowAllClick,
      onDeclineAllClick,
      onTrackingConsentToggle,
      onAuthCooieConsentToggle
    } = this.props;

    const {
      isStrictlyNecessaryDetailsOpen,
      isSiteAccessDetailsOpen,
    } = this.state;

    return (
      <SimpleModalWithHeader
        show={true}
        shouldTrapFocus={true}
        title="Privacy preferences"
        hideCloseIcon={!isConsentCookieSet}
        closeOnOuterClick={isConsentCookieSet}
        onRequestClose={this.handleClickOutside}
        className="consent-modal consent-preferences-modal"
      >
        <div className="consent-copy">
          <p>
            When you visit any website, it may store or retrieve information on
            your browser in the form of cookies. This information might be
            about you, your preferences or your device and is mostly used to
            make the site work as you expect.
          </p>

          <p>
            Because we respect your right to privacy, you can choose not to
            allow some types of cookies. You can also decline to allow us to
            track your site visit.
          </p>

          <p>
            <strong>Please note:</strong> blocking some types of cookies may impact your
            experience of the site and the services we are able to offer.
          </p>
        </div>

        <div className="consent-options-inline">
          <PrivacyPolicyLink url={privacyPolicyUrl} />

          <Button secondary onClick={onDeclineAllClick}>
            Decline all
          </Button>

          <Button
            primary
            tellRef={(ref)=> {
              if (!this.__mounted) {
                $(ref).focus();
              }
            }}
            onClick={onAllowAllClick}
          >
            Allow all
          </Button>
        </div>

        <h2>Manage preferences</h2>

        <div className="consent-cookies-list">

          <CookieListOption 
            cookieType="Strictly necessary cookies"
            cookieTypeId="strictly-necessary"
            cookieTypeDescription={`
              These cookies are necessary for the website to function and
              cannot be switched off in our systems. They are only set in
              response to actions made by you which amount to a request for
              services, such as setting your privacy preferences or viewing the
              site. You may refuse the use of strictly necessary cookies by
              changing your browser settings, but this may affect how the
              website functions.
            `}
            isChecked={true}
            isDisabled={true}
            isDetailsOpen={isStrictlyNecessaryDetailsOpen}
            cookieDetails={[
              {
                name: 'session',
                host: window.location.host,
                duration: '1 year',
                type: 'First Party',
                category: 'Strictly Necessary Cookies',
                description: 'This enables us to attribute a unique user ID to this device, in order to grant you access.'
              },
              {
                name: 'consent',
                host: window.location.host,
                duration: '1 year',
                type: 'First Party',
                category: 'Strictly Necessary Cookies',
                description: 'This allows us to store your privacy preferences in order to comply with relevant privacy regulations.'
              },
            ]}
            onToggle={noop}
            onCookieDetailsClick={()=> {
              this.setState({
                isStrictlyNecessaryDetailsOpen: !isStrictlyNecessaryDetailsOpen
              });
            }}
          />

          <CookieListOption 
            cookieType="Site access cookie"
            cookieTypeId="site-access"
            cookieTypeDescription={`
              If you were asked to identify yourself by name or email when
              you first accessed the site, this cookie allows us to remember
              who you are, so that you don’t need to re-authenticate next
              time you visit. If you accept the use site access cookies, you
              can switch this feature on.
            `}
            isChecked={hasConsentedToAuthCookie}
            isDisabled={false}
            isDetailsOpen={isSiteAccessDetailsOpen}
            cookieDetails={[
              {
                name: 'domain_auth_tkt',
                host: window.location.host,
                duration: '1 week',
                type: 'First Party',
                category: 'Functional Cookies',
                description: 'This allows us to remember your name and / or email address after you first authenticate to gain access to a secure site.'
              }
            ]}
            onToggle={()=> {
              onAuthCooieConsentToggle(!hasConsentedToAuthCookie);
            }}
            onCookieDetailsClick={()=> {
              this.setState({
                isSiteAccessDetailsOpen: !isSiteAccessDetailsOpen
              });
            }}
          />

          <CookieListOption 
            cookieType="Tracking"
            cookieTypeId="tracking"
            cookieTypeDescription={`
              Although we don’t use tracking cookies, we do count visits
              and traffic sources, so we can measure and improve the
              performance of our site. It helps us know which pages are the
              most and least popular and see how visitors move around the
              site. If you would prefer us not to do this, you can switch
              this feature off.
            `}
            isChecked={hasConsentedToTracking}
            isDisabled={false}
            isDetailsOpen={false}
            cookieDetails={[]}
            onToggle={()=> {
              onTrackingConsentToggle(!hasConsentedToTracking);
            }}
            onCookieDetailsClick={noop}
          />

        </div>
      </SimpleModalWithHeader>
    );
  }
}

const PrivacyPreferencesModalTrigger = ({ onClick })=> (
  <button className="consent-modal-trigger" onClick={onClick}>
    <GearIcon /> Manage Privacy Preferences
  </button>
);

export { PrivacyPreferencesModalTrigger };

export default withOnOutsideClick(PrivacyPreferencesModal);
